import React from 'react'
import {
  ContentSectionBlock,
  Col,
  Row,
  FormInput,
  FormInputSelect,
  FormInputDateRange,
  Card,
  Spinner,
  Button,
  FormInputCheckbox
} from 'camino-react'
import _ from 'lodash'
import moment from 'moment-timezone'
import Report from './Report'

import { cloudhelpGet } from '../../../utilities/CloudHelp'

import { humanize } from 'Utilities/StringManipulator'

export default class TicketTasksReport extends React.Component {
  constructor (props) {
    super(props)

    this.defaultFilters = {
      assignee_id: 'all',
      completer_id: 'all',
      group_by: 'assignee_name',
      task_date: 'created_at',
      display_all_tasks: false,
      date_from: moment(new Date()).subtract(1, 'months').seconds(0),
      date_to: moment(new Date()).seconds(0)
    }

    this.state = {
      groupBy: null,
      loadingTickets: false,
      filters: this.defaultFilters,
      userOptions: [],
      tasks: [],
      tasksNotFoundText: '',
      loadingSpinner: false,
      needToFilter: true
    }
  }

  componentDidMount () {
    this.fetchAssignees()
  }

  resetFilters = () => {
    this.setState({ filters: this.defaultFilters })
  }

  fetchAssignees = () => {
    cloudhelpGet('/api/clients/1/users?calligo_users=true')
      .then((response) => {
        const userOptions = _.sortBy(_.map(response.data, user => ({ label: user.name, value: user.id })), 'label')
        userOptions.unshift({ label: 'All', value: 'all' }, { label: 'Not set', value: null })
        this.setState({ userOptions })
      })
  }

  handleFilterInputChange = (filterName, value) => {
    const updateFilters = (state, props) => {
      const { filters } = state
      const newFilters = Object.assign({}, filters, { [filterName]: value })

      return (
        { filters: newFilters }
      )
    }

    this.setState(updateFilters)
  }

  submitFilters = () => {
    const { filters } = this.state
    const { endpoint } = this.props

    this.setState({ loadingSpinner: true, tasks: [] })
    cloudhelpGet(endpoint, { query: filters })
      .then(({ data: { tasks } }) => this.setState({
        tasks,
        tasksNotFoundText: _.isEmpty(tasks) ? 'Tasks not found' : '',
        loadingSpinner: false,
        needToFilter: false
      }))
  }

  render () {
    const {
      loadingTickets,
      filters,
      userOptions,
      tasks,
      tasksNotFoundText,
      loadingSpinner,
      needToFilter
    } = this.state

    const {
      date_from,
      date_to
    } = filters

    const defaultGroups = [
      {
        name: 'Assignee',
        taskField: 'assignee_name',
        labels: {
          undefined: '(No assignee)'
        }
      },
      {
        name: 'Ticket ID',
        taskField: 'ticket_id'
      },
      {
        name: 'Ticket Client',
        taskField: 'ticket_client'
      },
      {
        name: 'Completer',
        taskField: 'completer_name',
        labels: {
          undefined: '(No completer)'
        }
      }
    ]

    const selectInputFilters = [
      {
        title: 'Assignee',
        field: 'assignee_id',
        options: userOptions
      },
      {
        title: 'Completer',
        field: 'completer_id',
        options: userOptions
      },
      {
        title: 'Task date',
        field: 'task_date',
        options: _.map(['completed_at', 'created_at', 'updated_at', 'due_at'], dateType => (
          { value: dateType, label: humanize(dateType) }
        ))
      },
      {
        title: 'Group by',
        field: 'group_by',
        options: _.map(defaultGroups, ({ name, taskField }) => (
          { value: taskField, label: name }
        ))
      }
    ]

    return (
      <Card padding={false} allowOverflow>
        <ContentSectionBlock title="Filters" actions={[{ onClick: (e) => { this.resetFilters() }, text: 'Reset' }]}>
          <Row classExtra="thin-gutters">
            {_.map(selectInputFilters, ({ title, field, options }) => (
              <Col key={field}>
                <FormInput label={title}>
                  <FormInputSelect
                    placeholder={`Select ${title}`}
                    value={_.find(options, { value: filters[field] })}
                    options={_.map(options, ({ label, value }) => ({ label, value }))}
                    onValue={value => this.handleFilterInputChange(field, value)}
                    disabled={loadingTickets || filters.display_all_tasks}
                    isLoading={_.isEmpty(options)}
                  />
                </FormInput>
                {loadingTickets}
              </Col>
            ))}
            <Col>
              <FormInput label="Date Range">
                <FormInputDateRange
                  value={[date_from, date_to]}
                  onValue={(value) => {
                    this.handleFilterInputChange('date_from', value[0])
                    this.handleFilterInputChange('date_to', value[1])
                  }}
                  disabled={loadingTickets}
                />
              </FormInput>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormInput label="Display all tasks created between selected date range">
                <FormInputCheckbox
                  value={filters.display_all_tasks}
                  onValue={(value) => { this.handleFilterInputChange('display_all_tasks', value); this.setState({ needToFilter: !needToFilter }) }}
                  disabled={loadingTickets}
                />
              </FormInput>
            </Col>
          </Row>
          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
            <div><p>Use filters to display ticket tasks </p></div>
            <div>
              <Button onClick={() => this.submitFilters()}>Filter</Button>
            </div>
          </div>
        </ContentSectionBlock>
        <ContentSectionBlock>
          <div>{tasksNotFoundText}</div>

          {loadingSpinner && (<Spinner fill height={100} />)}

          {!_.isEmpty(tasks) && (<Report {...this.state} />)}
        </ContentSectionBlock>
      </Card>
    )
  }
}
